import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebaseConfig/firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button, Col, Container, Navbar, Row, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { paths } from "../../data/dataSourese";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { Login } from "../Login/Login";
import { UserContext } from "../../context/UserProvider";
import sahredStyles from "../../scss/sharedStyles.module.scss";
import { IdToTitle } from "../IdToTitle/IdToTitle";
import { DataContex } from "../../context/DataContext";

const getNivelAccesoNombre = (nivel) => {
  const niveles = {
    0: "Acceso Libre",
    1: "Nivel Bronce",
    2: "Nivel Plata",
    3: "Nivel Oro"
  };
  return niveles[nivel] || "Acceso Libre";
};

const MySwal = withReactContent(Swal);

export const MaterialABM = () => {
  const { obrasId } = useContext(DataContex);
  const { user, loading: userLoading } = useContext(UserContext);
  const navigate = useNavigate();

  const [recursos, setRecursos] = useState([]);
  const [recursosFiltrados, setRecursosFiltrados] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    tipo: "",
    titulo: "",
    obraID: "",
    descripcion: ""
  });
  const [titulosUnicos, setTitulosUnicos] = useState([]);
  const [tiposUnicos, setTiposUnicos] = useState([]);
  const [obrasIDUnicas, setObrasIDUnicas] = useState([]);

  const getRecursos = async () => {
    try {
      setIsLoading(true);
      const recursosRef = collection(db, "recursos");
      const data = await getDocs(recursosRef);
      const recursosData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      
      console.log('Total de recursos cargados:', recursosData.length);
      
      setRecursos(recursosData);
      setRecursosFiltrados(recursosData);
      
      // Extraer títulos, tipos y obrasID únicos
      const titulos = [...new Set(recursosData.map(r => r.title))].filter(Boolean);
      const tipos = [...new Set(recursosData.map(r => r.tipo))].filter(Boolean);
      const obrasID = [...new Set(recursosData.flatMap(r => r.obraIDs || []))].filter(Boolean);
      
      setTitulosUnicos(titulos.sort());
      setTiposUnicos(tipos.sort());
      setObrasIDUnicas(obrasID.sort());
    } catch (error) {
      console.error("Error al obtener recursos:", error);
      MySwal.fire({
        title: "Error",
        text: "Hubo un problema al cargar los recursos",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      getRecursos();
    } else {
      setRecursos([]);
      setRecursosFiltrados([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, MySwal]);

  const handleFiltroChange = (campo, valor) => {
    const nuevosFiltros = {
      ...filtros,
      [campo]: valor
    };
    setFiltros(nuevosFiltros);

    // Aplicar filtros inmediatamente
    let resultado = [...recursos];

    if (nuevosFiltros.tipo) {
      resultado = resultado.filter(recurso => recurso.tipo === nuevosFiltros.tipo);
    }

    if (nuevosFiltros.titulo) {
      resultado = resultado.filter(recurso => recurso.title === nuevosFiltros.titulo);
    }

    if (nuevosFiltros.obraID) {
      resultado = resultado.filter(recurso => (recurso.obraIDs || []).includes(nuevosFiltros.obraID));
    }

    // Filtro por descripción (búsqueda parcial, no sensible a mayúsculas/minúsculas)
    if (nuevosFiltros.descripcion) {
      resultado = resultado.filter(recurso => 
        recurso.description?.toLowerCase().includes(nuevosFiltros.descripcion.toLowerCase())
      );
    }

    setRecursosFiltrados(resultado);
  };

  const limpiarFiltros = () => {
    setFiltros({
      tipo: "",
      titulo: "",
      obraID: "",
      descripcion: ""
    });
    setRecursosFiltrados(recursos);
  };

  const handleClick = (url) => navigate(`/${url}`);

  const deleteRecurso = async (id) => {
    try {
      const recursoDoc = doc(db, "recursos", id);
      await deleteDoc(recursoDoc);
      await getRecursos();
    } catch (error) {
      console.error("Error al eliminar recurso:", error);
      MySwal.fire({
        title: "Error",
        text: "No se pudo eliminar el recurso",
        icon: "error",
      });
    }
  };

  const confirmDelete = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRecurso(id);
      }
    });
  };

  const handleViewFile = (pdfLink, id) => {
    if (pdfLink) {
      window.open(pdfLink, "_blank");
    } else {
      MySwal.fire({
        title: "Error",
        text: "No se encontró el archivo",
        icon: "error",
      });
    }
  };

  if (userLoading || isLoading) {
    return (
      <Container>
        <Row className="justify-content-center mt-5">
          <Col md={6} className="text-center">
            <h3>Cargando recursos...</h3>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container>
        <Row className="justify-content-center mt-5">
          <Col md={6}>
            <Login />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Row>
      <Container fluid>
        <div style={{
          position: "fixed",
          top: "90px",
          left: 0,
          right: 0,
          backgroundColor: "white",
          zIndex: 999,
          borderBottom: "1px solid #dee2e6",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <Container>
            <Navbar className="bg-white py-3">
              <Row className="w-100 align-items-end mb-3">
                <Col className="d-flex align-items-center">
                  <Button
                    variant="primary"
                    onClick={() => handleClick(paths.materialCreate)}>
                    Nuevo material
                  </Button>
                </Col>
                <Col className="d-flex align-items-center">
                  <Form.Group className="w-100">
                    <Form.Label>Tipo de Material</Form.Label>
                    <Form.Select
                      value={filtros.tipo}
                      onChange={(e) => handleFiltroChange("tipo", e.target.value)}>
                      <option value="">Todos</option>
                      {tiposUnicos.map(tipo => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col className="d-flex align-items-center">
                  <Form.Group className="w-100">
                    <Form.Label>Categoría</Form.Label>
                    <Form.Select
                      value={filtros.titulo}
                      onChange={(e) => handleFiltroChange("titulo", e.target.value)}>
                      <option value="">Todos</option>
                      {titulosUnicos.map(titulo => (
                        <option key={titulo} value={titulo}>{titulo}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col className="d-flex align-items-center">
                  <Form.Group className="w-100">
                    <Form.Label>Obra</Form.Label>
                    <Form.Select
                      value={filtros.obraID}
                      onChange={(e) => handleFiltroChange("obraID", e.target.value)}>
                      <option value="">Todas</option>
                      {obrasIDUnicas.map(obraID => (
                        <option key={obraID} value={obraID}>
                          {obraID}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col className="d-flex align-items-center">
                  <Button 
                    variant="outline-secondary"
                    onClick={limpiarFiltros}>
                    Limpiar Filtros
                  </Button>
                </Col>
                <Col md={3} className="d-flex align-items-center">
                  <Login />
                </Col>
              </Row>
            </Navbar>
              <Row className="w-100 mb-3">
                <Col>
                  <Form.Group>
                    <Row className="align-items-center">
                      <Col md={2}>
                        <Form.Label className="mb-0">Buscar por descripción</Form.Label>
                      </Col>
                      <Col>
                        <Form.Control
                          type="text"
                          placeholder="Buscar en las descripciones..."
                          value={filtros.descripcion}
                          onChange={(e) => handleFiltroChange("descripcion", e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
          </Container>
        </div>
        {/* Espaciador para compensar el navbar fijo */}
        <div style={{ height: "160px" }} />
        
        <Container>
          <div className="mt-3">
            <Row className="mb-3">
              <Col>
                <h5>Recursos encontrados: {recursosFiltrados.length}</h5>
              </Col>
            </Row>
            {recursosFiltrados.map((recurso, id) => (
              <li style={{ listStyle: "none" }} key={recurso.id || id}>
                <Row className="mb-4">
                  <Col md={12}>
                    <h4>{recurso.description} | {recurso.tipo}</h4>
                    <p>
                      Obra(s) Relacionada(s):{" "}
                      <b>
                        <IdToTitle id={recurso.obraIDs || []} data={obrasId} />
                      </b>
                    </p>
                    <p>{recurso.descargas} descargas</p>
                    <p>
                      Nivel de Acceso:{" "}
                      <b>{getNivelAccesoNombre(recurso.nivelAcceso || 0)}</b>
                    </p>
                  </Col>
                  <Col>
                    <Button
                      variant="primary"
                      onClick={() => navigate(`/${paths.editMaterial}/${recurso.id}`)}>
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </Button>
                  </Col>
                  <Col>
                    <Button onClick={() => confirmDelete(recurso.id)}>
                      <FontAwesomeIcon icon={faTrashCan} />
                    </Button>
                  </Col>
                  <Col>
                    <Button onClick={() => handleViewFile(recurso.link, recurso.id)}>
                      Ver Archivo
                    </Button>
                  </Col>
                  <Row
                    className={`mt-3 mb-3`}
                    style={{ margin: "0 px 0 0px" }}>
                    {Array.from(recurso.niveles || []).map((data, id) => (
                      <Col
                        key={id}
                        md={2}
                        className={`${sahredStyles.ciclo}`}>
                        {data}
                      </Col>
                    ))}
                  </Row>
                </Row>
              </li>
            ))}
          </div>
        </Container>
      </Container>
    </Row>
  );
};
